<template>
    <div>
        <h2>{{ title }}</h2>
        <ion-grid class="ion-padding-top">
            <ion-row>
                <ion-col
                    size="6"
                    v-for="(ereignis, key) in ereignisse"
                    :key="key"
                    class="c-image-card"
                >
                    <ion-card
                        class="ion-text-center"
                        button
                        @click="
                            $emit('change', [
                                {
                                    id: 'schadenArt',
                                    value: ereignis.title,
                                },
                            ])
                        "
                    >
                        <img :src="ereignis.image" />
                        <div class="c-image-card__text">
                            {{ ereignis.title }}
                        </div>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { BASEURL } from "@/utils/globals";

export default {
    props: {
        mode: {
            required: true,
            type: String,
        },
        title: {
            required: false,
            type: String,
            default: "Was ist passiert?",
        },
    },
    components: {},
    data() {
        return {
            imageFolder: "",
            ereignisse: [],
        };
    },
    mounted() {
        if (this.mode === "kfz") {
            this.imageFolder =
                "/content/dam/klickmal/me1ns/schadensmeldung/kfz/";
            this.ereignisse = [
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_parkschaden.png",
                    title: "Parkschaden",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_kollision-kfz.png",
                    title: "Kollision mit fremdem KFZ",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_vandalismus.png",
                    title: "Vandalismus",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_scheibe.png",
                    title: "Windschutzscheibe",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_kollision-sachen.png",
                    title: "Kollision mit Gegenstand",
                },
                {
                    image:
                        BASEURL + this.imageFolder + "schadensmeldung_wild.png",
                    title: "Wildschaden",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_sonstiges.png",
                    title: "Sonstiges",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_einbruch.png",
                    title: "Einbruch/Diebstahl",
                },
            ];
        } else if (this.mode === "haushalt") {
            this.imageFolder =
                "/content/dam/klickmal/me1ns/schadensmeldung/haushalt/";
            this.ereignisse = [
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_haftpflicht.png",
                    title: "Haftpflicht",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_glasbruch.png",
                    title: "Glasbruch/-schaden",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_feuer.png",
                    title: "Feuer",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_sturm.png",
                    title: "Sturm",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_hagel.png",
                    title: "Hagel",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_ueberschwemmung.png",
                    title: "Überschwemmung",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_erdrutsch.png",
                    title: "Erdrutsch",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_einbruch.png",
                    title: "Einbruch/Diebstahl/Vandalismus",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_sonstiges.png",
                    title: "Sonstiges",
                },
            ];
        } else if (this.mode === "recht") {
            this.imageFolder =
                "/content/dam/klickmal/me1ns/schadensmeldung/recht/";
            this.ereignisse = [
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_haftpflicht.png",
                    title: "Privat-Rechtsschutz",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_rechtsschutz_kfz.png",
                    title: "Kfz-Rechtsschutz",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_rechtsschutz_lenker.png",
                    title: "Lenker-Rechtsschutz",
                },
            ];
        } else if (this.mode === "sach") {
            this.imageFolder =
                "/content/dam/klickmal/me1ns/schadensmeldung/sach/";
            this.ereignisse = [
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_hagel_auto.png",
                    title: "KFZ",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_hagel_haus.png",
                    title: "Wohnung/Haus",
                },
            ];
        } else if (this.mode === "krankenhaus") {
            this.imageFolder =
                "/content/dam/klickmal/me1ns/schadensmeldung/krankenhaus/";
            this.ereignisse = [
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_unfall.png",
                    title: "Unfall",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_krank.png",
                    title: "Krankheit",
                },
            ];
        } else if (this.mode === "unfall") {
            this.imageFolder =
                "/content/dam/klickmal/me1ns/schadensmeldung/unfall/";
            this.ereignisse = [
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_kollision-kfz.png",
                    title: "Verkehrsunfall",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_unfall_arbeit.png",
                    title: "Arbeitsunfall",
                },
                {
                    image:
                        BASEURL +
                        this.imageFolder +
                        "schadensmeldung_unfall_freizeit.png",
                    title: "Freizeitunfall",
                },
            ];
        }
    },
};
</script>

<style lang="scss" scoped>
.c-image-card {
    img {
        width: 80px;
        margin: auto;
    }
    ion-card {
        margin-bottom: 0;
        height: 100%;
    }
    &__text {
        line-height: 1.25;
    }
}
</style>
